<div class="d-flex">
  @if(tabs && tabs.length) {
    <div class="history-cards">
      @for(tab of tabs; track tab) {
        @if(tab.entityId && !tab.hidden) {
          <div class="history-card" [ngClass]="{ 'history-card--active': activeTab && activeTab.name === tab.name }" (click)="selectActiveTab(tab)">
            <div class="title">{{ 'label.'+tab.name | translate }}</div>
          </div>
        }
      }
    </div>
  }
  <div class="w-100">
    @if(items && items.length) {
      @for(item of items; track item) {
        <div class="history-container d-flex">
          <div class="date-time">
            <div class="date">{{ helperService.adjustDateFormatToUTCByAddingZ(item.changeDate) | date }}</div>
            <div class="time">{{ helperService.adjustDateFormatToUTCByAddingZ(item.changeDate) | date: 'HH:mm' }}</div>
          </div>
          <div class="history-item">
            <div class="user-action"><span class="user-name">
              @if(item.impersonatedBy) {
                <i class="bi bi-person-bounding-box" title="{{'label.impersonated_by' | translate: { user: item.impersonatedBy } }}"></i>
              }
              {{item.changedBy}}</span> {{ ('label.' + item.operation) | translate }} <span class="table-name">{{ ('label.historyTable.' + item.tableName) | translate }}</span></div>
            @for(field of item.changesArray; track field) {
              @if(!isFieldHidden(field.FieldName)) {
                <div class="field">
                  <div class="label">{{ (translationPrefix + 'fields.' + decapitalize(field.FieldName) + '.label') | translate }} </div>
                  <div class="value">
                    @if(field.OldValue) {
                      @if (field.NewValue) {
                        <div class="from">{{ 'label.from' | translate }}</div>
                      }
                    @if(field.htmlField) {
                    <div class="preview-html" [ngClass]="{'red': !field.NewValue}" title="{{'label.preview_content_description' | translate }}"
                      (click)="previewHtml('label.old_value', field.OldValue)">{{ 'label.preview_content' | translate }}</div>
                    } @else if(field.dateField) {
                      <div [ngClass]="{'red': !field.NewValue}">{{ helperService.adjustDateFormatToUTCByAddingZ(field.OldValue) | date: 'yyyy-MM-dd' }}</div>
                    } @else {
                      <div [ngClass]="{'red': !field.NewValue}">{{ field.OldValue }}</div>
                    }
                      @if (field.NewValue) {
                        <div class="to" >{{ 'label.to' | translate }}</div>
                      }
                    }
                    @if(field.htmlField) {
                    <div [ngClass]="{'green': field.OldValue}" (click)="previewHtml('label.new_value', field.NewValue)"
                      class="preview-html">{{ 'label.preview_content' | translate }}</div>
                    } @else if(field.dateField) {
                      <div [ngClass]="{'green': field.OldValue}">{{ helperService.adjustDateFormatToUTCByAddingZ(field.NewValue) | date: 'yyyy-MM-dd' }}</div>
                    } @else {
                      <div [ngClass]="{'green': field.OldValue}">{{ field.NewValue }}</div>
                    }
                  </div>
                </div>
              }
            }
          </div>
        </div>
        }
    } @else {
      <div class="no-items-global">{{ 'label.no-history' | translate }}</div>
    }
  </div>
</div>
